import { ResumeLanguage } from '../../types';

interface LanguagesSectionProps {
    languages: ResumeLanguage[];
    onChange: (languages: ResumeLanguage[]) => void;
}

const blankLanguage = (): ResumeLanguage => ({
    id: crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36),
    language: '',
    level: '',
});

export function LanguagesSection({ languages, onChange }: LanguagesSectionProps) {
    const handleChange = (id: string, updates: Partial<ResumeLanguage>) => {
        onChange(languages.map(language => (language.id === id ? { ...language, ...updates } : language)));
    };

    const handleAdd = () => {
        onChange([...languages, blankLanguage()]);
    };

    const handleRemove = (id: string) => {
        onChange(languages.filter(language => language.id !== id));
    };

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold">Languages</h3>
                <button
                    type="button"
                    onClick={handleAdd}
                    className="text-sm text-primary-600 hover:text-primary-800"
                >
                    + Add language
                </button>
            </div>

            {languages.map((language, index) => (
                <div key={language.id} className="border border-gray-200 rounded-lg p-3 space-y-2">
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-500">Entry {index + 1}</span>
                        <button
                            type="button"
                            onClick={() => handleRemove(language.id)}
                            className="text-xs text-red-500"
                        >
                            Remove
                        </button>
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        <input
                            className="input"
                            placeholder="Language"
                            value={language.language}
                            onChange={(e) => handleChange(language.id, { language: e.target.value })}
                        />
                        <input
                            className="input"
                            placeholder="Level (e.g., Fluent)"
                            value={language.level || ''}
                            onChange={(e) => handleChange(language.id, { level: e.target.value })}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}
